export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  backBtn: "nav-back-the-fleet-button",
  story: "nav-story-link",
  progress: "nav-progress-link",
  tiers: "nav-tiers-link",
  wall: "nav-wall-link",
  admin: "nav-admin-link",
};

export const HERO = {
  donateBtn: "hero-donate-button",
  pledgeBtn: "hero-pledge-button",
};

export const PROGRESS = {
  bar: "fundraising-progress-bar",
  raised: "progress-raised-amount",
  goal: "progress-goal-amount",
  backers: "progress-backers-count",
  daysLive: "progress-days-live",
  daysLeft: "progress-days-left",
};

export const TIERS = {
  card: (id) => `tier-card-${id}`,
  donate: (id) => `tier-donate-button-${id}`,
  pledge: (id) => `tier-pledge-button-${id}`,
};

export const DONATE = {
  modal: "donate-modal",
  amount: "donate-amount-input",
  name: "donate-name-input",
  email: "donate-email-input",
  message: "donate-message-input",
  anonymous: "donate-anonymous-checkbox",
  submit: "donate-submit-button",
  close: "donate-close-button",
};

export const PLEDGE = {
  modal: "pledge-modal",
  amount: "pledge-amount-input",
  name: "pledge-name-input",
  email: "pledge-email-input",
  message: "pledge-message-input",
  anonymous: "pledge-anonymous-checkbox",
  submit: "pledge-submit-button",
  close: "pledge-close-button",
};

export const WALL = {
  list: "wall-of-support-list",
  item: (i) => `wall-item-${i}`,
};

export const SUB = {
  email: "subscribe-email-input",
  submit: "subscribe-submit-button",
};

export const AI = {
  bubbleOpen: "ai-chat-bubble-open-button",
  panel: "ai-chat-panel",
  input: "ai-chat-input",
  send: "ai-chat-send-button",
  close: "ai-chat-close-button",
  thankYouBtn: (id) => `admin-thankyou-button-${id}`,
  thankYouDialog: "admin-thankyou-dialog",
  thankYouCopy: "admin-thankyou-copy-button",
  updateBullets: "admin-update-bullets-input",
  updateGenerate: "admin-update-generate-button",
  updateOutput: "admin-update-output",
  updateCopy: "admin-update-copy-button",
};

export const ADMIN = {
  email: "admin-email-input",
  password: "admin-password-input",
  loginBtn: "admin-login-button",
  logoutBtn: "admin-logout-button",
  goalInput: "admin-goal-edit-input",
  goalSave: "admin-goal-save-button",
  tabDonations: "admin-tab-donations",
  tabPledges: "admin-tab-pledges",
  tabSubs: "admin-tab-subscribers",
};
